export default __webpack_public_path__ + "static/CorprateHp_07-4428cb6139ef3ad80422e1608c0e9b23.jpg";